import { FunctionComponent, useCallback } from "react";
import { IconButton } from "@ui-kit/IconButton/IconButton";
import { useNavigate } from "@hooks/useNavigate/useNavigate";
import { selectIsDisableLists } from "@store/client/clientReducer";
import { useAppSelector } from "@store/store";
import { ExternalIcon } from "@icons/ExternalIcon";

interface EntityBackButtonProps {
  variant?: "close" | "back";
}

const EntityBackButton: FunctionComponent<EntityBackButtonProps> = ({
  variant = "back",
}) => {
  const navigate = useNavigate();
  const isDisableLists = useAppSelector(selectIsDisableLists);

  const handlePress = useCallback(() => {
    if (!window.history.state?.idx || window.history.state?.idx === 0) {
      navigate("/");
    } else {
      navigate(-1);
    }
  }, [navigate]);

  if (isDisableLists) {
    return null;
  }

  return (
    <IconButton
      icon={
        variant === "back" ? (
          <ExternalIcon size={18} svgName="arrow-left" />
        ) : (
          <ExternalIcon size={18} svgName="close" />
        )
      }
      onPress={handlePress}
    />
  );
};

export { EntityBackButton };
